import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteDesignationMutation } from "../../services/appln";

export default function DeleteDesignation(props: any): any {
  return (
    <DeletePanel
      useIcon={true}
      deleteMutation={useDeleteDesignationMutation}
      deleteArgs={{ id: props.id }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteDesignationTitle}
      confirmationDialogMsg={strings.deleteDesignationConfirmation}
      errorDialogTitle={strings.deleteDesignationFailedTitle}
      errorDialogMsg={strings.deleteDesignationFailedMsg}
    />
  );
}
